export function addDays(
    zdt: Temporal.ZonedDateTime,
    days: number,
): Temporal.ZonedDateTime {
    return zdt.add({ days });
}

export function addDaysToDate(date: Date, days: number): Date {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}

export function startOf(
    zdt: Temporal.ZonedDateTime,
    unit: "day" | "hour" | "minute" | "month" | "year",
) {
    switch (unit) {
        case "day":
            return zdt.with({
                hour: 0,
                minute: 0,
                second: 0,
                millisecond: 0,
                microsecond: 0,
                nanosecond: 0,
            });
        case "hour":
            return zdt.with({
                minute: 0,
                second: 0,
                millisecond: 0,
                microsecond: 0,
                nanosecond: 0,
            });
        case "minute":
            return zdt.with({
                second: 0,
                millisecond: 0,
                microsecond: 0,
                nanosecond: 0,
            });
        case "month":
            return zdt.with({
                day: 1,
                hour: 0,
                minute: 0,
                second: 0,
                millisecond: 0,
                microsecond: 0,
                nanosecond: 0,
            });
        case "year":
            return zdt.with({
                month: 1,
                day: 1,
                hour: 0,
                minute: 0,
                second: 0,
                millisecond: 0,
                microsecond: 0,
                nanosecond: 0,
            });
    }
}

export function endOf(
    zdt: Temporal.ZonedDateTime,
    unit: "day" | "hour" | "minute" | "month" | "year",
) {
    switch (unit) {
        case "day":
            return zdt.with({
                hour: 23,
                minute: 59,
                second: 59,
                millisecond: 999,
                microsecond: 0,
                nanosecond: 0,
            });
        case "hour":
            return zdt.with({
                minute: 59,
                second: 59,
                millisecond: 999,
                microsecond: 0,
                nanosecond: 0,
            });
        case "minute":
            return zdt.with({
                second: 59,
                millisecond: 999,
                microsecond: 0,
                nanosecond: 0,
            });
        case "month":
            return addDays(startOf(zdt.add({ months: 1 }), "day"), -1).with({
                hour: 23,
                minute: 59,
                second: 59,
                millisecond: 999,
                microsecond: 0,
                nanosecond: 0,
            });
        case "year":
            return zdt.with({
                month: 12,
                day: 31,
                hour: 23,
                minute: 59,
                second: 59,
                millisecond: 999,
                microsecond: 0,
                nanosecond: 0,
            });
    }
}
